/// <amd-module name="Repos/Views/PullRequest/Util/Visit" />
import { IVssPageContext } from "VSS/Platform/Context";
import { IdentityRef } from "VSS/Platform/Contracts/WebApi";
import { IVssContributionService } from "VSS/Platform/Contribution";
import { ViewedStatus } from "./Viewed";

const visitDataProviderId = "ms.vss-code-web.pr-detail-visit-data-provider";

export interface IPullRequestVisitData {
    artifactId: string;
    lastVisitedDate: Date;
    previousLastVisitedDate: Date;
    user: IdentityRef;
    viewedState: string;
}

export interface IPullRequestVisitUpdate {
    repositoryId: string;
    pullRequestId: number;
    modifyHashes: string[];
    modifyViewedStatus: ViewedStatus;
}

export function getVisitData(pageContext: IVssPageContext): IPullRequestVisitData | undefined {
    const contributionService = pageContext.getService<IVssContributionService>("IVssContributionService");
    const visit = contributionService.getData<{ visit: IPullRequestVisitData }>(visitDataProviderId);
    if (visit) {
        return visit.visit;
    }
}

export function updateVisitData(pageContext: IVssPageContext, updateRequest: IPullRequestVisitUpdate): void {
    const contributionService = pageContext.getService<IVssContributionService>("IVssContributionService");
    contributionService.getDataAsync<{}>(visitDataProviderId, updateRequest, true);
}
